import { useState, useEffect } from 'react';
import { obtenerNombreDepartamento } from "../../../api/departamentos";
import { toast } from "react-toastify";

function NombreDepartamento(props) {
    const { folio } = props;

    // Para almacenar el nombre del cliente
    const [nombreDepartamento, setNombreDepartamento] = useState("");

    useEffect(() => {
        //
        try {
            obtenerNombreDepartamento(folio).then(response => {
                const { data } = response;
                // console.log(data)
                const { nombre } = data;
                setNombreDepartamento(nombre)
            }).catch(e => {
                //console.log(e)
                if (e.message === 'Network Error') {
                    //console.log("No hay internet")
                    toast.error("Conexión al servidor no disponible");
                }
            })
        } catch (e) {
            console.log(e)
        }
    }, [folio]);

    return (
        <>
            {nombreDepartamento}
        </>
    );
}

export default NombreDepartamento;